import { defineAsyncComponent } from 'vue'
export default {
  "blank-full": defineAsyncComponent(() => import("/vercel/path0/layouts/blank-full.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  order: defineAsyncComponent(() => import("/vercel/path0/layouts/order.vue").then(m => m.default || m))
}